import {
  getAuthenticatedThemisClient,
  AdminCurrencyConfigurationView,
} from '@modifi/onboarding-api-clients'
import {CollectionFactory, Reducer} from '@modifi/redux'
import {createSelector} from 'reselect'
import {ProductTypeVal} from '@modifi/enums'

import {AppThunkAction} from '../../types/redux'

const client = getAuthenticatedThemisClient()

const {selectors, reducer, actions} = CollectionFactory({
  reducerPath: ['data', 'currencies', 'collection'],
  actionNamePrefix: 'data/currencies',
  entityPrimaryKeySelector: currencyConfig => currencyConfig.id!,
  fetchRequest: (state, params) => {
    let queryParams = {}
    if (params?.productType) {
      queryParams = {productType: params.productType}
    }
    return client.StaticData.fetchCurrencies(queryParams).then(res => {
      const currencyConfig = res.data()
      return [{...currencyConfig, id: 'dummy'}]
    })
  },
})

export default reducer as Reducer

const selectCurrencyConfigByProductType = (
  state: Record<string, any>,
  productType: string
): AdminCurrencyConfigurationView => selectors.selectByKeyWindow(state, {productType})[0] || {}

export const selectFinancingCurrenciesByProductType = createSelector(
  selectCurrencyConfigByProductType,
  currencyConfig => currencyConfig?.financingCurrencies || []
)

const aFetchCurrencyConfigByProductType = (productType: ProductTypeVal): any =>
  actions.fetch({productType})

export const aEnsureFetchCurrenciesByProductType =
  (productType: ProductTypeVal): AppThunkAction<void> =>
  (dispatch, getState): void => {
    const financingCurrencies = selectFinancingCurrenciesByProductType(getState(), productType)
    if (!financingCurrencies || financingCurrencies?.length < 1) {
      dispatch(aFetchCurrencyConfigByProductType(productType))
    }
  }
